var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockerRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5134_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.4164V10.2494C16.5 8.5949 15.1545 7.2494 13.5 7.2494C11.8455 7.2494 10.5 8.5949 10.5 10.2494V11.4164C9.6075 11.9369 9 12.8939 9 13.9994V15.4994C9 17.1539 10.3455 18.4994 12 18.4994H15C16.6545 18.4994 18 17.1539 18 15.4994V13.9994C18 12.8939 17.3925 11.9369 16.5 11.4164ZM13.5 15.8744C12.879 15.8744 12.375 15.3704 12.375 14.7494C12.375 14.1284 12.879 13.6244 13.5 13.6244C14.121 13.6244 14.625 14.1284 14.625 14.7494C14.625 15.3704 14.121 15.8744 13.5 15.8744ZM15 10.9994H12V10.2494C12 9.42215 12.6727 8.7494 13.5 8.7494C14.3273 8.7494 15 9.42215 15 10.2494V10.9994ZM8.658 18.5024H3.75C1.68225 18.5024 0 16.8202 0 14.7524V7.7954C0 6.54665 0.618 5.3849 1.65225 4.68665L6.90225 1.14365C8.1765 0.284148 9.8235 0.284148 11.0977 1.14365L16.5 4.80365C17.439 5.51015 18 6.61115 18 7.7954V10.2494C18 7.76765 15.9818 5.7494 13.5 5.7494C11.0182 5.7494 9 7.76765 9 10.2494V10.6634C8.05875 11.5086 7.5 12.7214 7.5 13.9994V15.4994C7.5 16.6544 7.941 17.7052 8.658 18.5024Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerRoom);
export default __webpack_public_path__ + "static/media/LockerRoom.87b620a8d9242274a1928c787a0b26de.svg";
export { ForwardRef as ReactComponent };